import { render, staticRenderFns } from "./bi-loading.vue?vue&type=template&id=86e8f5c4&"
import script from "./bi-loading.vue?vue&type=script&lang=ts&"
export * from "./bi-loading.vue?vue&type=script&lang=ts&"
import style0 from "./bi-loading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports